/* Contact page scripts: reveal animations and the Live Chat card. Moved from templates/page.contact.json so browsers can cache them (6 Oct 2026). */

(function() {
  function initContactAnimations() {
    var targets = document.querySelectorAll('.mcc-contact__hero-inner, .mcc-contact__faq-inner, .mcc-contact__trust-inner, .mcc-contact__details-inner');
    if (targets.length === 0) {
      setTimeout(initContactAnimations, 200);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    targets.forEach(function(el) {
      observer.observe(el);
    });

    // Scroll fallback
    window.addEventListener('scroll', function() {
      targets.forEach(function(el) {
        if (!el.classList.contains('is-visible')) {
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.85) {
            el.classList.add('is-visible');
          }
        }
      });
    });

    // Immediate check
    targets.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) {
        el.classList.add('is-visible');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactAnimations);
  } else {
    initContactAnimations();
  }
})();


(function() {
  function addChatCard() {
    var grid = document.querySelector('.mcc-contact__details-grid');
    if (!grid) { setTimeout(addChatCard, 200); return; }
    
    // Check if already added
    if (grid.querySelector('.mcc-contact__details-card--chat')) return;
    
    var card = document.createElement('div');
    card.className = 'mcc-contact__details-card mcc-contact__details-card--chat';
    card.setAttribute('data-action', 'open-chat');
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.innerHTML = '<div class="mcc-contact__details-card-icon"><svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" width="24" height="24"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"></path></svg></div><div class="mcc-contact__details-card-title">Live Chat</div><div class="mcc-contact__details-card-value">Start a conversation</div>';
    grid.appendChild(card);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addChatCard);
  } else {
    addChatCard();
  }
})();
